import qrcode from '../../qrHash'

let qr

if (process.env.VUE_APP_MODE === 'local' || process.env.VUE_APP_MODE === 'white') {
  qr = qrcode['white']
} else if (process.env.VUE_APP_MODE === 'kura') {
  qr = qrcode['kura']
} else {
  qr = {}
}

const ja = { id: 'ja', name: '日本語' }
const us = { id: 'us', name: 'English' }
const kr = { id: 'kr', name: '한국어' }
const ch = { id: 'zh-cn', name: '简体字' }
const tw = { id: 'zh-tw', name: '繁體字' }

const getLanguages = (lang) => {
  switch (lang) {
    case 'ja':
      return [ja, us, kr, ch, tw]
    case 'zh-tw':
      return [tw, us, ja]
    case 'zh-cn':
      return [ch, us, ja]
    case 'us':
      return [us, ja]
    default:
      return []
  }
}

const config = {
  baseUrl: process.env.VUE_APP_BASE_API_URL, // APIのurl
  domain: process.env.VUE_APP_DOMAIN, // 静的ファイルをホスティングするドメイン
  seatStatusCheckInterval: 10000, // 10秒ごとに座席状況確認
  unit: {
    ja: ['皿', '本', '個', '杯'],
    us: ['Plate', 'Bottle', ' Piece', 'Cup'],
    kr: ['접시', '개', '개', '잔'],
    'zh-cn': ['盘', '瓶', '份', '杯'],
    'zh-tw': ['盤', '瓶', '份', '杯'],
  },
  languages: getLanguages(process.env.VUE_APP_LANG),
  qr: qr, // ローカル開発用QR（のハッシュ値
  mutenShops: [
    // 店舗IDが下記のものと一致する際に無添蔵のロゴを使用する
    500, // 無添蔵泉北
    504, // 無添蔵伊丹昆陽
    505, // 無添蔵北花田
    506, // 無添蔵紀伊川辺
  ],
  authRetryCount: 10, // 認証に再挑戦する回数
  authKuraPriceInfoErrorRetryCount: 5, // くら側の皿価格設定取得に再挑戦する回数
  authKuraPriceInfoErrorCode: '403-5', // くら側の皿価格設定取得に失敗した場合のエラーコード
  errorMessages: {
    202: {
      ja: '認証に失敗しました。\n\nQRコードを読み取り直してください。(202)',
      us: 'Authentication failed. \n\nPlease scan QR CODE again.(202)',
      'zh-tw': '認證失敗\n\n請重新掃QR CODE(202)',
      'zh-cn': '认证失败\n\n请扫描二维码(202)',
    },
    server: {
      ja: '読み取りに失敗しました。\n\nシステムエラーの可能性があります。お手数ですが店舗スタッフへお問い合わせください。(202)',
      us: 'Confirmation Failed.\n\nSystem error has occurred. Please ask the staff for help.(202)',
      'zh-tw': '讀取失敗\n\n發生系統錯誤。請向店員尋求疑難排解(202)',
      'zh-cn': '读取失败\n\n发生系统错误。请向店内工作人员寻求帮助。(202)',
    },
    others: {
      ja: '読み取りに失敗しました。\n\n通信環境をお確かめの上、QRコードを読み取り直してください。\n\n解消されない場合はお手数ですが店舗スタッフへお問い合わせください。(000)',
      us: 'Confirmation failed.\n\nPlease check your network status and scan the QR code again.\n\n Please ask the staff for help if the problem persists.(000)',
      'zh-tw':
        '讀取失敗\n\n請確認您的網路環境,並重新掃描QR CODE\n\n若仍無法解決,請向店員尋求協助(000)',
      'zh-cn':
        '读取失败\n\n请确认您的网络环境，并重扫二维码\n\n若仍无法解决，请向店员寻求协助(000)',
    },
  },
  maxSameTimeOrderCount: 4,
}
export default config
